import { render, staticRenderFns } from "./view01.vue?vue&type=template&id=bb3dc8c4&"
import script from "./view01.vue?vue&type=script&lang=js&"
export * from "./view01.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports